/**
 * Single source of truth for "should this comment action be routed through the
 * V2G `/v2g/v1/` endpoints?".
 *
 * The standard `/lct/v1/` comment endpoints use DEMAND_MODE email routing,
 * which means any comment on a V2G EVCP (linked inverter present) — whether
 * from a V2G assessor, manufacturer, or DNO — would notify demand assessors
 * instead of V2G assessors. Routing via `/v2g/v1/` ensures the correct party
 * receives the notification.
 *
 * The V2G endpoints accept all roles that can comment on EVAC devices
 * (sys admin, DNO, V2G assessor, manufacturer), so routing based on device
 * alone is safe.
 *
 * @param isV2gDevice - whether the device under inspection is a V2G EVCP
 *                       (i.e. has a `linkedInverterRef`).
 * @returns `true` whenever the device is a V2G EVCP, regardless of the
 *          caller's role. Falls through to standard LCT routing otherwise.
 */
export const useV2gCommentRouting = (isV2gDevice = false): boolean =>
    !!isV2gDevice
